import { getTemplateCategoryId, TEMPLATE_CATEGORY } from "./templates/utils";

export const getSelectedPhoneNumber = (integrationListNewStructure, integrated_channel_id, phone_number_id) => {
    if(integrationListNewStructure){
        const obj = integrationListNewStructure.find((list) => list.integrated_channel_id == Number(integrated_channel_id));

        if(obj && "meta_integration_phone_number_data" in obj){
            const selectedPhoneNumber = obj.meta_integration_phone_number_data?.find((phone) => phone.phone_number_id == phone_number_id);
            if(selectedPhoneNumber){ 
                return selectedPhoneNumber;
            }
        }
    } 
    return null; 
}

export const getEmptyAssignContactRecipientPayload = (channel_authoriser_user_data_id, channel_id, integrationListNewStructure, integrated_channel_id, phone_number_id) => {
    return {
        contact_list_id: 0,
        contact_id: [0], 
        chatbot_id: 0,
        channel_authoriser_user_data_id: channel_authoriser_user_data_id,
        channel_id: channel_id || 1,
        meta_integration_whatsapp_phone_number_id: getSelectedPhoneNumber(integrationListNewStructure, integrated_channel_id, phone_number_id) ? getSelectedPhoneNumber(integrationListNewStructure, integrated_channel_id, phone_number_id)?.meta_integration_whatsapp_phone_number_id || 0 : 0,
    }
} 

export const getInitialWhatsappTemplateObject = (whatsappTemplateTypes, isTemplateLibrary = false, templateLibraryCategoryList = []) => ({
    whatsapp_template_id: null,
    "meta_integration_whatsapp_id": 0,
    "whatsapp_template_type_id": whatsappTemplateTypes?.find((types) => types.name?.toLowerCase() === "basic")?.whatsapp_template_type_id || 1,
    "whatsapp_template_flag_interactive_message": false,
    "whatsapp_template_flag_flow": false,
    "interactive_type_id": null,
    "interactive_list_button_text": null,
    "flag_named_parameter": isTemplateLibrary? true : false,
    "whatsapp_template_data": {
        "whatsapp_template_data_id": null,
        "whatsapp_template_category_id": isTemplateLibrary
            ? getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList)
            : getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateLibraryCategoryList),
        "whatsapp_language_id": isTemplateLibrary ? 15 : 0,
        "whatsapp_template_name": "",
        ...(isTemplateLibrary && {
            whatsapp_template_display_name: "Untitled Template",
        }),
        "whatsapp_template_description": "",
        "whatsapp_template_header": {
            "whatsapp_template_header_type_id": 0,
            "whatsapp_template_header_type_name": "None",
            "whatsapp_template_header_data": [
                {
                    "whatsapp_template_header_data_value": "",
                    "whatsapp_template_header_data_id": 0,
                    "whatsapp_template_header_data_google_storage_id": 0,
                    "whatsapp_template_header_variable_data": []
                }
            ]
        },
        "whatsapp_template_body": {
            "whatsapp_template_body_value": "",
            "whatsapp_template_body_description": "",
            "whatsapp_template_body_variable_data": []
        },
        "whatsapp_template_button": [],
        "whatsapp_template_footer": {
            "whatsapp_template_footer_id": "",
            "whatsapp_template_footer_value": ""
        },
        "whatsapp_template_carousel": {
            "whatsapp_template_carousel_header": "",
            "whatsapp_template_carousel_header_dynamic_variable": [],
            "whatsapp_template_carousel_card": [
                {
                    "whatsapp_template_header": {
                        "whatsapp_template_header_type_id": 0,
                        "whatsapp_template_header_type_name": null,
                        "whatsapp_template_header_data": [
                            {
                                "whatsapp_template_header_data_value": "",
                                "whatsapp_template_header_data_id": 0,
                                "whatsapp_template_header_data_google_storage_id": 0,
                                "whatsapp_template_header_variable_data": []
                            }
                        ],
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_value": "",
                        "whatsapp_template_body_description": "",
                        "whatsapp_template_body_variable_data": [],
                    },
                    "whatsapp_template_button": [],
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_value": "",
                        "whatsapp_template_footer_id": null,
                    }
                },
                {
                    "whatsapp_template_header": {
                        "whatsapp_template_header_type_id": 0,
                        "whatsapp_template_header_type_name": null,
                        "whatsapp_template_header_data": [
                            {
                                "whatsapp_template_header_data_value": "",
                                "whatsapp_template_header_data_id": 0,
                                "whatsapp_template_header_data_google_storage_id": 0,
                                "whatsapp_template_header_variable_data": []
                            }
                        ]
                    },
                    "whatsapp_template_body": {
                        "whatsapp_template_body_value": "",
                        "whatsapp_template_body_description": "",
                        "whatsapp_template_body_variable_data": [],
                    },
                    "whatsapp_template_button": [],
                    "whatsapp_template_footer": {
                        "whatsapp_template_footer_value": "",
                        "whatsapp_template_footer_id": null,
                    }
                }
            ]
        },
        "whatsapp_template_security_recommendation": false,
        "whatsapp_template_code_expiration_minutes": null
    }
})

export const AGENT_ACTIVITY_MESSAGE_TYPES = {
    AGENT_ASSIGNED: 'agent_assigned',
    AGENT_JOINED: 'agent_joined',
    AGENT_LEFT: 'agent_left'
}